import React from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetHeaderCloseButton,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import ScopeChangeRequestFinalizedDialogViewModel from './ScopeChangeRequestFinalizedDialogViewModel'
import { useBrandingSettings } from 'hooks/branding'
import Button from 'components/Button'
import styles from './ScopeChangeRequestFinalizedDialogViewModel.sass'

interface ScopeChangeRequestFinalizedDialogProps {
  vm: ScopeChangeRequestFinalizedDialogViewModel
}

export default observer(function ScopeChangeRequestFinalizedDialog({
  vm,
}: ScopeChangeRequestFinalizedDialogProps) {
  const { corporateMode } = useBrandingSettings()
  const isClientApprovalRequired =
    vm.scopeChangeRequest.workspace.config.combined_pricing
      ?.job_scope_require_client_approval

  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader>
        <div className={styles.closeButtonContainer}>
          <ModalSheetHeaderCloseButton dataTest="scope-change-request-close-finalized-dialog" />
        </div>
      </ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          {!corporateMode && (
            <ModalSheetContentIllustration
              src={require('assets/images/img_welcome.svg')}
              alt="Thank you for your response"
            />
          )}
          <ModalSheetContentTitle>
            Thank you for your response
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            You have accepted the job scope updates sent by{' '}
            <span className={styles.collaboratorName}>
              {vm.scopeChangeRequest.createdBy.displayName}
            </span>
            {isClientApprovalRequired && (
              <>
                {' '}
                and will be shared with{' '}
                <span className={styles.collaboratorName}>
                  {vm.scopeChangeRequest.jobClient?.member.displayName}
                </span>{' '}
                next for their approval
              </>
            )}
            .
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            onClick={vm.close}
            type="default"
            dataTest="scope-change-request-close-finalized"
          >
            Close
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
